@use "ui/styles/colorsOld";

$input-focus-width: var(--input-focus-width);
$margin-left: var(--margin-left);
$margin-right: var(--margin-right);

.wrapper {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 4px;
  display: flex;
  margin: 4px $margin-right 4px $margin-left;
  position: relative;
  z-index: 0;

  &:focus-within {
    background-color: colorsOld.$white;
    border-color: colorsOld.$sapphireLight;
  }

  label {
    order: -1;

    &:hover {
      background-color: colorsOld.$white;
      border: 1px solid colorsOld.$stoneLightX1;
      color: colorsOld.$stoneDarkX1;
    }
  }

  :global {
    .search-icon {
      margin-right: 6px;
    }

    .clear {
      color: colorsOld.$stone;
      cursor: pointer;
      display: none;
      margin-right: 6px;
      position: absolute;
      right: 0px;
      z-index: 10;

      &:hover {
        color: colorsOld.$stoneLight;
      }
    }

    .search-button {
      border: 1px solid transparent;
      border-radius: 4px;
      align-items: center;
      display: flex;
      padding: 6px 12px 6px 6px;
      color: colorsOld.$stoneDark;

      &:hover {
        cursor: pointer;
      }

      &:active {
        background-color: colorsOld.$white;
        border: 1px solid colorsOld.$sapphireLight;
      }
    }

    .search {
      background-color: colorsOld.$white;
      outline: none;
      border: none;
      padding: 0;
      width: 0;
      height: 100%;
      z-index: 10;
      transition-duration: 0.4s;

      &[placeholder] {
        text-overflow: ellipsis;
      }

      &:focus,
      &.simulate-focus {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        padding: 0 24px 0 0;
        width: $input-focus-width;

        & + label {
          background-color: colorsOld.$white;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          padding-right: 0;

          span {
            display: none;
          }
        }

        & ~ .clear {
          align-items: center;
          display: inline-flex;
        }
      }
    }
  }
}
